<div class="row">
    <a class="employee-name" [routerLink]="['/employees', 'directory', hrId]" target="_blank">
        {{ value }}
    </a>
    <span class="vertical-label"> ID {{ hrId }} </span>
</div>
